const TWO_FACTOR_STEPS = {
  CONFIRM_PASSWORD: 0,
  WELCOME: 1,
  SCAN: 2,
  CONFIRM: 3,
  SUCCESS: 4,
};

export default TWO_FACTOR_STEPS;
